import { createColumnHelper } from "@tanstack/react-table";
import clsx from "clsx";
import { TokenIcon } from "components/TokenIcon";
import { formatDollarAmount } from "services/formatDollarAmount";
import { PoolBase } from "types/pool";
import { TokenDetail } from "types/tokens";

const columnHelper = createColumnHelper<PoolBase>();

const renderCountOfOthersTokens = (tokens: TokenDetail[]) => {
  const count = tokens.slice(5).length;

  if (count === 0) return null;

  return (
    <div
      className={
        "bg-secondary flex h-[24px] w-[24px] items-center justify-center rounded-full bg-[#F0F4FF] text-[8px] dark:bg-blue-darkMode-30 sm:h-[40px] sm:w-[40px]"
      }
    >
      +{count}
    </div>
  );
};

export const columns = [
  columnHelper.accessor("name", {
    id: "name",
    enableSorting: false,
    header: () => (
      <p className=" px-2 text-sm font-bold uppercase text-gray-600 dark:text-white">
        Pool name
      </p>
    ),
    cell: (info) => (
      <p className="px-2 text-sm font-bold text-navy-700 dark:text-white">
        {info.getValue()}
      </p>
    ),
  }),
  columnHelper.accessor("tokens", {
    id: "tokens",
    enableSorting: false,
    header: () => (
      <p className="text-sm font-bold uppercase text-gray-600 dark:text-white">
        Assets
      </p>
    ),
    cell: (info) => (
      <div className="flex items-center">
        {info
          .getValue()
          .slice(0, 5)
          .map((token, index) => (
            <TokenIcon
              src={token.token.iconUrl}
              key={token.token.address}
              address={token.token.address}
            >
              {(src: string) => (
                <img
                  className={`h-[24px] w-[24px] rounded-full`}
                  alt={token.token.name}
                  src={src}
                  width={40}
                  height={40}
                />
              )}
            </TokenIcon>
          ))}
        {renderCountOfOthersTokens(info.getValue())}
      </div>
    ),
  }),
  columnHelper.accessor("metrics.global.totalUsdInvested", {
    id: "metrics.global.totalUsdInvested",
    enableSorting: false,
    header: () => (
      <p className=" px-2 text-sm font-bold uppercase text-gray-600 dark:text-white">
        Total Pool Cap
      </p>
    ),
    cell: (info) => (
      <p className="px-2 text-sm font-bold text-navy-700 dark:text-white">
        {formatDollarAmount(info.getValue(), 2, 2, "$")}
      </p>
    ),
  }),
  columnHelper.accessor("volume24hUsd", {
    id: "volume24hUsd",
    enableSorting: false,
    header: () => (
      <p className=" px-2 text-sm font-bold uppercase text-gray-600 dark:text-white">
        Volume(24h)
      </p>
    ),
    cell: (info) => (
      <p className="px-2 text-sm font-bold text-navy-700 dark:text-white">
        {formatDollarAmount(info.getValue(), 2, 2, "$")}
      </p>
    ),
  }),
  columnHelper.accessor("metrics.global.pnlInUsd", {
    id: "metrics.global.pnlInUsd",
    enableSorting: false,
    header: () => (
      <p className=" px-2 text-sm font-bold uppercase text-gray-600 dark:text-white">
        PNL
      </p>
    ),
    cell: (info) => (
      <p className="px-2 text-sm font-bold text-navy-700 dark:text-white">
        {formatDollarAmount(info.getValue(), 2, 2, "$")}
      </p>
    ),
  }),
  columnHelper.accessor("isPaused", {
    id: "isPaused",
    enableSorting: false,
    header: () => (
      <p className="text-sm font-bold uppercase text-gray-600 dark:text-white">
        Status
      </p>
    ),
    cell: (info) => (
      <p
        className={clsx(
          "text-sm font-bold  dark:text-white",
          info.getValue() ? "text-red-600" : "text-green-600"
        )}
      >
        {info.getValue() ? "Paused" : "Active"}
      </p>
    ),
  }),
];
